<template>
  <ul v-if="posts">
    <li
      v-for="post in posts"
      :key="post.postId"
    >
      <DrillPostListItem
        :post="post"
        :mastered-post-ids="masteredPostIds"
      />
    </li>
  </ul>
</template>
<script>
import { Category, User } from '@/api'
import DrillPostListItem from '@/components/molecules/DrillPostListItem'

export default {
  name: 'DrillPostList',

  components: {
    DrillPostListItem,
  },

  props: {
    categorySlug: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      posts: [],
      masteredPostIds: [],
    }
  },

  created() {
    this.fetchPosts({ order: 'asc' })
    this.setPostsMastered()
  },

  methods: {
    async fetchPosts(params = {}) {
      const params_copied = { ...params }
      this.$store.dispatch('setLoading', true)
      try {
        const res = await Category.getPostsBySlug(
          this.serviceId,
          this.categorySlug,
          params_copied,
          this.userToken
        )
        this.posts = res.items
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        this.debugOutput(err)
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },

    async setPostsMastered() {
      let params = {
        count: 100,
        order: 'asc',
      }
      this.$store.dispatch('setLoading', true)
      try {
        const items = await User.getPostsMastered(this.serviceId, params, this.userToken)
        items.map((item) => {
          this.masteredPostIds.push(item.postId)
        })
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        this.debugOutput(err)
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },
  },
}
</script>
